import React from "react"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Dialog from "@mui/material/Dialog"
import Typography from "@mui/material/Typography"
import CTA from "components/atoms/CTA"

type ActionButton = {
  label: string;
  mode: "primary" | "white";
  loading: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

type DialogProps = {
  open: boolean;
  message?: string | React.ReactNode;
  icon: React.ReactNode;
  buttons: ActionButton[];
  disableBackdropClose?: boolean;
  onClose?: () => void;
}

export default function StyledDialog(props: DialogProps) {
  const {
    open,
    message,
    icon,
    buttons,
    disableBackdropClose = false,
    onClose
  } = props

  return (
    <Dialog
      onClose={(event, reason) => {
        if (disableBackdropClose && reason === "backdropClick") return
        if (onClose) onClose()
      }}
      open={open}
      disableEscapeKeyDown={disableBackdropClose}
      PaperProps={{
        style: {
          width: "100%",
          maxWidth: "calc((var(--max-container-width) - 48px))",
          margin: "24px",
          padding: "24px",
          borderRadius: "32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "24px"
        }
      }}
    >
      <IconWrapper>
        {icon}
      </IconWrapper>
      <Message>{message}</Message>
      <ButtonsWrapper>
        {buttons.map((button, index) => (
          <CTA
            key={button.label}
            variant={index === 0 ? "contained" : "outlined"}
            loading={button.loading}
            disabled={button.disabled || false}
            onClick={button.onClick}
          >
            {button.label}
          </CTA>
        ))}
      </ButtonsWrapper>
    </Dialog>
  )
}

const ButtonsWrapper = styled(Stack)(() => ({
  width: "100%",
  flexDirection: "row",
  alignItems: "center",
  gap: "8px"
}))

const Message = styled(Typography)(({ theme }) => ({
  fontSize: "1.4rem",
  fontWeight: 400,
  color: theme.palette.gray["14"],
  textAlign: "center"
}))

const IconWrapper = styled("div")(() => ({
  "& svg": {
    width: "64px",
    height: "64px"
  }
}))
